import React from "react";
import { Form, Input, Button, Row, Col, Icon, Spin } from "antd";
import { Country, State, City } from "country-state-city";
import countryList from "react-select-country-list";
import { debounce } from "lodash";
import { connect } from "react-redux";
import * as actions from "../../actions";

const labelStyle = {
  fontSize: "16px",
  width: "100%",
  textAlign: "left",
  whiteSpace: "normal",
  display: "inline-flex",
};

const orLabelStyle = {
  fontSize: "16px",
  width: "100%",
  textAlign: "left",
}

const noPadding = {
  paddingLeft: "0px",
  paddingRight: "0px",
  paddingTop: "0px",
  paddingBottom: "0px",
  display: "flex",
  justifyContent: "center",
};

class DutyAndTax extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: false,
      CountryISOEnum: {},
      shouldValidate: false
    };
  }

  findISOCodeByCountryName = (countryName) => {
    // console.log("countryName: ", countryName);
    if (countryName === "USA") {
      countryName = "United States";
    }
    const list = countryList().getData();
    //console.log("list: ", list);
    const country = list.find((c) => c.label === countryName);
    return country ? country.value : null;
  };

  // Function to remove accents/diacritics from a string
  removeAccents = (str) => {
    return str.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
  };

  // Function to normalize city names (convert to lowercase and remove accents)
  normalizeCityName = (cityName) => {
    return this.removeAccents(cityName).toLowerCase();
  };

  findStateCodeByCityAndCountryName = (cityName, countryName) => {
    let cityFound = null;
    if (countryName === "Canada") {
      // First, find the country code based on the country name
      const country = Country.getAllCountries().find(
        (c) => c.name === countryName
      );
      if (!country) return null; // Country not found
      // console.log("country: ", country, country.isoCode);
      // find all states within this country
      const states = State.getStatesOfCountry(country.isoCode);
      // console.log("states: ", states);
      // find the city by name within the found states
      for (let state of states) {
        const cities = City.getCitiesOfState(country.isoCode, state.isoCode);
        const city = cities.find(
          (c) =>
            this.normalizeCityName(c.name) === this.normalizeCityName(cityName)
        );
        // console.log("cities: ", cities, "city: ", city);
        if (city) {
          cityFound = city;
          break;
        }
      }
    }
    // Return the state code of the found city, or null if not found
    return cityFound ? cityFound.stateCode : null;
  };


  calculateHsCodeFromDescription = async (
    product_desc,
    origin,
    destination,
    index
  ) => {
    const payload = {
      description: product_desc,
      origin_country_code: origin,
      destination_country_code: destination,
    };
    try {
      // Real classification API (was stubbed to a hardcoded HS code). Get_Product_HSCode
      // returns the action results ({ HSCode }) or undefined when none is found.
      const response = await this.props.Get_Product_HSCode(payload);
      if (response && response.HSCode) {
        // Get the current dutyTax values from the form
        const dutyTax = this.props.form.getFieldValue("dutyTax");
        // Create a copy of the dutyTax array
        const updatedDutyTax = [...dutyTax];

        // Update hsCode for the specific index
        updatedDutyTax[index].hs_code = response.HSCode;

        // Update the form with the new hsCode value
        this.props.form.setFieldsValue({
          dutyTax: updatedDutyTax,
        });
        return response.HSCode;
      } else {
        console.log("Error while getting HS code from API");
        return null;
      }
    } catch (err) {
      console.error(err);
    }
  };

  calculateDutyAndTax = debounce(async () => {
    const { form } = this.props;
    const values = form.getFieldsValue(["dutyTax"]);
  
    // console.log("-----values----", values);
  
    // Check if user has started filling any field in commodityArr
    const shouldValidate = values.dutyTax.some(
      (duty) =>
        duty?.description === undefined || duty?.description === "" ||
        duty?.hs_code === undefined || duty?.hs_code === "" ||
        duty?.quantity === undefined || duty?.quantity === "" ||
        duty?.amount === undefined || duty?.amount === ""
    );
  
    // console.log("----shouldValidate-----", shouldValidate);
  
    if (shouldValidate) {
      // **Enable required validation**
      this.setState({ shouldValidate: true }, () => {
        let validationFields = [];
        values.dutyTax.forEach((duty, index) => {
          validationFields.push(
            `dutyTax[${index}].description`,
            `dutyTax[${index}].hs_code`,
            `dutyTax[${index}].quantity`,
            `dutyTax[${index}].amount`
          );
        });
  
        console.log("validationFields: ", validationFields);
  
        // **Now enforce validation**
        form.validateFields(validationFields, { force: true }, (errors, values) => {
          if (!errors) {
            // console.log("Validated successfully:", values);
            this.handleDutyAndTax();
          } else {
            console.error("Validation errors found: ", errors);
          }
        });
      });
    } else {
      // console.log("Skipping validation as no fields were entered.");
      this.handleDutyAndTax();
      return;
    }
  });

  handleDutyAndTax = debounce(() => {
    // antd v3 form.validateFields WITHOUT a callback returns a Promise that REJECTS on
    // failure (it never resolves falsy), so `await`ing it made the `if (!isValid)` guard
    // dead code and turned a validation failure into an uncaught rejection. Use the
    // callback form: errors is truthy only when validation fails (#7).
    this.props.form.validateFields(["dutyTax"], async (errors, values) => {
      if (errors) {
        console.log("Form validation failed, cannot calculate duty and tax.");
        return;
      }

      const { dutyTax } = values;
      this.setState({ loading: true });

      // Collect necessary data from props or state
      const formData = dutyTax;

      // Prepare request body
      const ship_from_country = this.findISOCodeByCountryName(
        this.props.queryParams.from.country
      );
      const ship_to_country = this.findISOCodeByCountryName(
        this.props.queryParams.to.country
      );
      // const ship_from_state_code = this.findStateCodeByCityAndCountryName(
      //   this.props.queryParams.from.name,
      //   this.props.queryParams.from.country
      // );
      const ship_to_state_code = this.findStateCodeByCityAndCountryName(
        this.props.queryParams.to.name,
        this.props.queryParams.to.country
      );

      // We need to handle all async calls to fetch missing HS codes before building the request body
      const updatedItems = await Promise.all(
        formData.map(async (item, index) => {
          let hsCode = item.hs_code;

          // If hsCode is missing and description is present, fetch the hsCode from description
          if (!hsCode && item.description) {
            hsCode = await this.calculateHsCodeFromDescription(
              item.description,
              ship_from_country,
              ship_to_country,
              index
            );
          }

          return {
            quantity: Number(item.quantity),
            amount: Number(item.amount),
            hsCode: hsCode, // Set the hsCode (may be null if it couldn't be fetched)
            description: item.description,
          };
        })
      );

      // Prepare request body after HS codes are populated
      const requestBody = {
        items: updatedItems,
        origin_country_code: ship_from_country,
        destination_country_code: ship_to_country,
        destination_state_code: ship_to_state_code,
        input_currency_code: "USD",
        shipping_cost:
          this.props?.final_search_form?.selected_card_json?.bookNowPrice ||
          this.props?.final_search_form?.selected_card_detail?.bookNowPrice,
      };

      try {
        const response = await this.props.Get_Duty_And_Tax(requestBody);
        if (response) {
          this.props.onDutyTaxAmountSubtotalChange(response);
        }
      } catch (error) {
        console.error("Error calculating duty and tax:", error);
      } finally {
        this.setState({ loading: false });
      }
    });
  }, 300); // Debounce time in milliseconds (adjust as needed)

  validateEitherFieldTest = (index, rule, value, callback) => {
    const { getFieldValue } = this.props.form;
    const productDescription = getFieldValue(`dutyTax[${index}].description`);
    const hsCode = getFieldValue(`dutyTax[${index}].hs_code`);

    if (!productDescription && !hsCode) {
      callback("required description or HS code");
    } else {
      callback();
    }
  };

  render() {
    const { dutyTax, onDutyTaxChange, onAddDutyTax, onDeleteDutyTax, form } =
      this.props;
    const { getFieldDecorator } = form;

    return (
      <Form>
        {dutyTax.map((duty, index) => (
          <Form.Item
            key={index}
            label={
              index === 0 ? (
                <span style={{...labelStyle, fontWeight:"bold"}}>What items are in this shipment?</span>
              ) : (
                ""
              )
            }
          >
            <div key={index}>
              <Row
                gutter={[{ xs: 8, sm: 16, md: 24, lg: 32 }, 16]}
                //style={{ display: "flex" }}
              >
                <Col xs={24} sm={24} md={11}>
                  <Form.Item
                    label={<span style={labelStyle}>Product Description</span>}
                    style={{ marginBottom: "0" }}
                  >
                    {getFieldDecorator(`dutyTax[${index}].description`, {
                      initialValue: duty?.description || "",
                      rules: this.state.shouldValidate ? [
                        {
                          validator: (rule, value, callback) =>
                            this.validateEitherFieldTest(
                              index,
                              rule,
                              value,
                              callback
                            ),
                        },
                      ] :
                      [],
                    })(
                      <Input
                        size="large"
                        autoComplete="off"
                        placeholder="For example: Nike air or Guitar"
                        onChange={(e) => {
                          onDutyTaxChange(index, "description", e.target.value);
                        }}
                      />
                    )}
                  </Form.Item>
                </Col>

                {/* "Or" Label */}
                <Col xs={24} sm={24} md={2} style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
                  <span style={{ ...orLabelStyle, textAlign: "center" }}>Or</span>
                </Col>


                <Col xs={24} sm={24} md={11}>
                  <Form.Item
                    label={<span style={labelStyle}>HS Code</span>}
                    style={{ marginBottom: "0" }}
                  >
                    {getFieldDecorator(`dutyTax[${index}].hs_code`, {
                      initialValue: duty?.hs_code || "",
                      rules: this.state.shouldValidate ? [
                        {
                          validator: (rule, value, callback) =>
                            this.validateEitherFieldTest(
                              index,
                              rule,
                              value,
                              callback
                            ),
                        },
                      ]
                      :
                      [],
                    })(
                      <Input
                        size="large"
                        autoComplete="off"
                        placeholder="HS Code"
                        onChange={(e) => {
                          onDutyTaxChange(index, "hs_code", e.target.value);
                        }}
                      />
                    )}
                  </Form.Item>
                </Col>
              </Row>
              <Row gutter={[{ xs: 8, sm: 16, md: 24, lg: 32 }, 16]}>
                <Col xs={24} sm={24} md={11}>
                  <Form.Item
                    label={<span style={labelStyle}>Product Quantity</span>}
                    style={{ marginBottom: "0" }}
                  >
                    {getFieldDecorator(`dutyTax[${index}].quantity`, {
                      initialValue: duty?.quantity || "",
                      rules: [
                        {
                          //required: true,
                          required: this.state.shouldValidate,
                          message: "required",
                        },
                        {
                          pattern: /^-?\d+$/, // Regular expression to accept integers
                          message: "Please enter a valid quantity",
                        },
                      ],
                    })(
                      <Input
                        size="large"
                        autoComplete="off"
                        placeholder="1"
                        onChange={(e) => {
                          onDutyTaxChange(index, "quantity", e.target.value);
                        }}
                      />
                    )}
                  </Form.Item>
                </Col>

                <Col xs={24} sm={24} md={2} style={noPadding}>
                  <div className="or-span">
                    <span //style={labelStyle}
                    ></span>
                  </div>
                </Col>

                <Col xs={24} sm={24} md={11}>
                  <Form.Item
                    label={<span style={labelStyle}>Product Price</span>}
                    style={{ marginBottom: "0" }}
                  >
                    {getFieldDecorator(`dutyTax[${index}].amount`, {
                      initialValue: duty?.amount || "",
                      rules: [
                        {
                          //required: true,
                          required: this.state.shouldValidate,
                          message: "required",
                        },
                        {
                          pattern: /^\d+(\.\d+)?$/, // Regular expression to accept integers or decimal numbers
                          message: "Please enter a valid price",
                        },
                      ],
                    })(
                      <Input
                        size="large"
                        autoComplete="off"
                        placeholder="Price"
                        addonBefore={
                          <span className="input-prefix">$ USD</span>
                        }
                        onChange={(e) => {
                          onDutyTaxChange(index, "amount", e.target.value);
                        }}
                      />
                    )}
                  </Form.Item>
                </Col>
              </Row>
              <Row>
                {/* Other input fields */}
                <Col xs={24} sm={24} md={8} lg={6}>
                  <div style={{ display: "flex", paddingTop: "1rem" }}>
                    <Button
                      type="primary"
                      onClick={onAddDutyTax}
                      style={{
                        width: "100%",
                        marginRight: dutyTax.length > 1 ? "10px" : "0px",
                      }}
                      ghost
                    >
                      <Icon type="plus" /> Add
                    </Button>
                    {dutyTax.length > 1 && (
                      <Button
                        type="danger"
                        onClick={() => onDeleteDutyTax(index)}
                        style={{ width: "100%" }}
                        ghost
                      >
                        <Icon type="minus" /> Delete
                      </Button>
                    )}
                  </div>
                </Col>
              </Row>
            </div>
            {/* )} */}
          </Form.Item>
        ))}
        <Row gutter={[{ xs: 8, sm: 16, md: 24, lg: 32 }, 16]}>
        <Col xs={24} sm={12} md={12} lg={12}>
        {/* <Row>
        <Col xs={24} sm={24} md={8} lg={6}> */}
        <div style={{ display: "flex", flexDirection: "column", //paddingTop: "1rem"
         }}>
        <Button
          onClick={this.calculateDutyAndTax}
          disabled={this.state.loading}
          style={{
            backgroundColor: "#ECECEC",
            marginBottom: "1rem",
            color: "#000",
          }}
        >
          Calculate Duty and Tax
          {this.state.loading && (
            <Spin
              style={{
                marginLeft: "10px",
                marginRight: "10px",
              }}
              indicator={<Icon type="loading" style={{ fontSize: 24 }} spin />}
            />
          )}
        </Button>
        </div>
        </Col>
        </Row>
      </Form>
    );
  }
}
const mapStateToProps = (state) => {
  return {
    queryParams: state.route.queryParams,
    user: state.route.USER_DETAILS,
    saveDataShowOverlay: state.code_config.saveDataShowOverlay,
    transaction_type: state.code_config.transactionType,
    initAuth: state.code_config.initAuth,
  };
};

export default connect(mapStateToProps, actions)(DutyAndTax);
